/** A progressive, accessible index of the headings Shopify actually renders. */
function setupPolicyIndex() {
  const body = document.querySelector('.shopify-policy__body');
  if (!body || body.closest('.etolie-policy-layout')) return;

  const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
  if (headings.length < 2) return;

  const layout = document.createElement('div');
  layout.className = 'etolie-policy-layout';
  const index = document.createElement('details');
  index.className = 'etolie-policy-toc';
  const summary = document.createElement('summary');
  summary.textContent = window.etolieT("Na tej stronie");
  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', window.etolieT("Spis treści"));

  headings.forEach((heading, position) => {
    if (!heading.id) {
      const base = `etolie-policy-section-${position + 1}`;
      let id = base;
      let suffix = 1;
      while (document.getElementById(id)) id = `${base}-${suffix++}`;
      heading.id = id;
    }
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    // Let the browser retain native hash navigation/history. Move keyboard focus
    // to the same heading so the next Tab does not resume inside the index.
    link.addEventListener('click', () => {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    });
    nav.append(link);
  });

  index.append(summary, nav);
  const mobile = window.matchMedia('(max-width: 749px)');
  const sync = () => { index.open = !mobile.matches; };
  sync();
  mobile.addEventListener('change', sync);
  body.before(layout);
  layout.append(index, body);
}

setupPolicyIndex();
